import {
  DEFAULT_ICON_COLOR,
  DEFAULT_ICON_SIZE,
} from "@oneleet/config/constants";
import { cn } from "@oneleet/utils";

export function CustomGatekeeperIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className={cn(
        "fill-transparent stroke-current",
        DEFAULT_ICON_SIZE,
        DEFAULT_ICON_COLOR,
        className,
      )}
    >
      <path
        d="M10 12.6667V11.3333C10 10.8029 9.78929 10.2942 9.41421 9.91911C9.03914 9.54404 8.53043 9.33333 8 9.33333C7.46957 9.33333 6.96086 9.54404 6.58579 9.91911C6.21071 10.2942 6 10.8029 6 11.3333V12.6667C6 12.8435 5.92976 13.013 5.80474 13.1381C5.67971 13.2631 5.51014 13.3333 5.33333 13.3333H2.66667C2.48986 13.3333 2.32029 13.2631 2.19526 13.1381C2.07024 13.013 2 12.8435 2 12.6667V3.33333H4.66667V5.33333H6.66667V3.33333H9.33333V5.33333H11.3333V3.33333H14V12.6667C14 12.8435 13.9298 13.013 13.8047 13.1381C13.6797 13.2631 13.5101 13.3333 13.3333 13.3333H10.6667C10.4899 13.3333 10.3203 13.2631 10.1953 13.1381C10.0702 13.013 10 12.8435 10 12.6667Z"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7.33333H14"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
